import Vue from 'vue'
import Router from 'vue-router'
import Homepage from '@/view/homepage/index.vue'
import Install from '@/view/install/index.vue'
import Document from '@/view/document/index.vue'
import Example from '@/view/example/index.vue'
import Simulator from '@/view/simulator/index.vue'
import Contact from '@/view/contact/index.vue'


import Start from '@/view/start/index.vue'
import Preprocess from '@/view/preprocess/index.vue'
import Simulation from '@/view/simulation/index.vue'
import Download from '@/view/download/index.vue'
import Ipynb from '@/view/Ipynb/index.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Homepage',
      component: Homepage
    },
    {
      path: '/Install',
      name: 'Install',
      component: Install
    },
    {
      path: '/Document',
      name: 'Document',
      component: Document
    },
    {
      path: '/Example',
      name: 'Example',
      component: Example
    },
    {
      path:'/Simulator',
      name:'Simulator',
      component:Simulator
    },
    {
      path:'/Contact',
      name:'Contact',
      component:Contact
    },
    {
      path:'/Preprocess',
      name:'Preprocess',
      component:Preprocess
    },
    {
      path:'/SCAN-ATAC_Preprocessing',
      name:'Ipynb',
      component:Ipynb
    },
    {
      path:'/Simulation',
      name:'Simulation',
      component:Simulation
    },
    {
      path:'/Download',
      name:'Download',
      component:Download
    },
    {
      path:'/Start',
      name:'Start',
      component:Start
    }
  ],


  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      //console.log(to.hash)
      return {
        selector: to.hash
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js